import { render } from "./Stampanti.vue?vue&type=template&id=3651af32&scoped=true"
import script from "./Stampanti.vue?vue&type=script&lang=js"
export * from "./Stampanti.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Stampanti.vue?vue&type=style&index=1&id=3651af32&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3651af32"]])

export default __exports__